module.exports = __webpack_public_path__ + "static/img/zzy48.94b4607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzy48.png
// module id = L6Kg
// module chunks = 73